import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as StoryActions from "../../data/stories/StoryActions";

import DuplicateStoryModal from './DuplicateStoryModal';

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    duplicate: StoryActions.duplicate,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DuplicateStoryModal)
);
